///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.thoughtspot = abcsetup.thoughtspot || {};
abcsetup.thoughtspot.edit = abcsetup.thoughtspot.edit || {};
abcsetup.thoughtspot.edit.thoughtspotevents = abcsetup.thoughtspot.edit.thoughtspotevents || {};




///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.thoughtspot.edit = {
    init: function() {
        abcsetup.setTitle(abcsetup.userRole === 'thoughtspot_team' ? 'Edit a ThoughtSpot Event' : 'Edit an Event');

        abcsetup.thoughtspot.common.init();
    },
}
